export const validatePassword = (password, confirm, id) => {
    if (!id) return { status: false, field: 'password', msg: '¡Para añadir un usuario debes ingresar una contraseña!' }
    if (password.length < 8) {
        return { status: false, field: 'password', msg: '¡Contraseña demasiado corta!' }
    } else if (password !== confirm) {
        return { status: false, field: 'password', msg: '¡Las contraseñas no coinciden!' }
    }
    return { status: true }
}